import {_} from 'lodash';
import {ICell, template as tpl, viewModel as SearchViewModel} from "../search/search";
import {IRouteDefinitionParams, IRuleset, ITableColumn, TRefKey} from "../../index";
import {global, lm} from "../../appContext";
import pubsub from "../../pubsub";
import {nsClone} from "../../clone/fn";
import {nsRuleset} from "./nsRuleset";
import {getObjectDefinition} from "../../util/misc";
import {nsReference} from "../../util/nsReference";
import {ISearchRowButtons} from "../search/index";
import * as ko from "knockout";
import {getHash} from "../../constants/RouteDefinitions";
import {ISplitButtonParams} from "@component/button/splitButton/split-button";
import {saveRulesetName} from "../search/inlineRenameSave";

export let template: string = tpl;

import getReferenceDefinition = nsReference.getReferenceDefinition;
import getRefsObjectWithoutReferenceToSubRulesets = nsRuleset.getRefsObjectWithoutReferenceToSubRulesets;

export class viewModel extends SearchViewModel {

    public TABLE: ITableColumn[] = [
        {
            key: "Id",
        },
        {
            key: "Name",
            getComponent: (item: IRuleset) => ({
                name: 'component/search/inline-rename',
                params: {
                    item,
                    canEdit: () => global.permissionValidator.isMinCompanyAdmin(),
                    lockedTitleKey: 'ruleset.rename.locked',
                    searchKey: this.searchkey,
                    save: (newName: string) => saveRulesetName(item, newName),
                },
            }),
        },
        {
            key: "ObjectTypeId",
            label: 'object type',
        },
        {
            key: 'rules',
            label: 'rule|p',
            count: true,
        },
        {
            key: "refs",
            label: 'used in',
            count: true,
        },
        {
            key: "func",
            label: '',
            validator: () => !this.selectedObjects().length,
        },
    ];

    protected override fnRow: KnockoutObservableArray<ISearchRowButtons> = ko.observableArray<ISearchRowButtons>([]);

    constructor(params: IRouteDefinitionParams) {
        super(params);

        this.populatePageButtons();
        this.kosub.subscribe(global.login.selectedOrganization, () => this.populatePageButtons());

        pubsub.on(this, "ruleset.copy.success", this.searchChangedHandler.bind(this));
        pubsub.on(this, "ruleset.delete.success", () => this.preSubmit(true, true, 0));
    }

    protected override getSearchSplitButtonParams(): ISplitButtonParams | null {
        return null
    }

    protected override getSearchHeaderSplitButtonParams(): ISplitButtonParams | null {
        return {
            mainButton: {
                cls: 'btn-action',
                icon: 'fa-plus',
                label: 'rulesets.ruleset.create',
                href: () => getHash('createruleset') ?? '',
                validator: () => global.permissionValidator.isMinCompanyAdmin(),
            },
        }
    }

    protected populatePageButtons() {
        this.fnRow.removeAll();

        if (global.permissionValidator.isMinCompanyAdmin()) {
            this.fnRow([
                {
                    icon: 'fa-ellipsis-v',
                    title: 'function|p',
                    getComponent: (ruleset: IRuleset) => {
                        return {
                            name: 'component/button/ellipsis-dropdown',
                            params: {
                                buttons: [
                                    {
                                        label: 'edit',
                                        href: () => getHash('editruleset', {id: ruleset.id}) ?? '',
                                    },
                                    {
                                        label: 'copy',
                                        onClick: () => nsRuleset.copyDialog(ruleset)
                                    },
                                    {
                                        label: 'preview',
                                        onClick: () => nsRuleset.fnPreviewRuleset(ruleset),
                                    },
                                    {
                                        label: 'delete',
                                        onClick: () => nsRuleset.trashDialog(ruleset),
                                        enabled: () => !Object.keys(ruleset.refs).length,
                                        cls: 'btn-danger btn-ready-calm',
                                    },
                                ],
                            },
                        }
                    }
                },
            ]);

        }
    }

    private searchChangedHandler() {
        if (global.login.selectedOrganization() === nsClone.targetOrg()) {
            this.preSubmit(true, true, 0);
        }
    }

    protected override getCellContent(obj: ICell): string | number {
        switch (obj.key) {
            case "ObjectTypeId": {
                const def = getObjectDefinition(obj.item.objecttype.id);
                return def ? (lm.t(def.singular) ?? '—') : '—';
            }
            case "refs":
                const ret = _.reduce(getRefsObjectWithoutReferenceToSubRulesets(obj.item), (total: number, refs: string[]) => {
                    return total + refs.length;
                }, 0);
                return ret ? ret : '—';
        }
        return super.getCellContent(obj);
    }

    protected override getCellText(obj: ICell): string {
        switch (obj.key) {
            case "refs":
                const ret: string[] = [];
                const refs = obj.item.refs;
                for (let key in refs) {
                    const def = getReferenceDefinition(key as TRefKey);
                    const ref = refs[key as TRefKey];
                    const str = `${def.name} (${ref.length})`;
                    ret.push(str);
                }
                return ret.join('\n')
        }
        return super.getCellText(obj);
    }
}
